<template>
  <div class="complex-wrap">
    <div style="font-size: 12px">拖动可调整顺序 <BatchEditImages v-model="tbForm[key]" @change="onChange" refName="imgs" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
    <MutiImgUpload
      ref="imgs"
      :mainImgNums="0"
      :limitNums="extraAttr.limitNums || 5"
      :imgs="tbForm[key] || []"
      v-bind="extraAttr"
      :auditFileList="auditFileList"
      :appendToBody="true"
      @change="onChange"
      @file-upload="handleImageUpload"
    />
  </div>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'

import storeMixins from '../store-mixins';

export default {
  components: {
    MutiImgUpload,
    BatchEditImages
  },
  mixins: [storeMixins],
  props: ['props'],
  computed: {
    key() {
      return this.props.name;
    },
    extraAttr() {
      return this.props.extraAttr || {};
    },
    auditFileList() {
      return this.$attrs.auditFileList;
    },
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateTbForm(newFormFields);
    },
    handleImageUpload(url) {
      this.$emit('file-upload', url);
    },
  },
  watch: {
    extraAttr: {
      handler(v) {
        if (v._needLimit) {
          this.$parent.rules.push({
            validator: async (rule, value, callback) => {
              let errMsg = await this.$refs.imgs.method_validImage();
              if (errMsg) {
                callback(new Error(errMsg));
              } else {
                callback();
              }
            },
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>